import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "@mui/material/Button";
import DropdownMenu from "react-dd-menu";

class StatusFilterMenu extends Component {
  constructor() {
    super();
    this.click = this.click.bind(this);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      isMenuOpen: false
    };
  }

  componentWillUnmount(){
    this.toggle = () => {};
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.toggle();
  }

  click(e) {
    this.props.onChange({
      term: "status",
      title: e.currentTarget.innerText,
      code: e.currentTarget.id,
      id: ""
    });
  }

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: <Button onClick={this.toggle}>{this.props.title}</Button>,
      align: "left",
    };

    return (
      <DropdownMenu {...menuOptions}>
        <li><a href="#" id="allnotcompleted" onClick={this.click}>All Open</a></li>
        <li role="separator" className="separator" />
        <li><a href="#" id="unassigned" onClick={this.click}>Unassigned</a></li>
        <li><a href="#" id="assigned" onClick={this.click}>Assigned</a></li>
        <li><a href="#" id="inreview" onClick={this.click}>In Review</a></li>
        <li><a href="#" id="internalrejection" onClick={this.click}>Internal Rejection</a></li>
        <li><a href="#" id="customerrejection" onClick={this.click}>Customer Rejection</a></li>
        <li><a href="#" id="completed" onClick={this.click}>Completed</a></li>
        <li><a href="#" id="closed" onClick={this.click}>Closed</a></li>
        <li><a href="#" id="cancelled" onClick={this.click}>Cancelled</a></li>
        <li><a href="#" id="all" onClick={this.click}>All Statuses</a></li>
        </DropdownMenu>
    );
  }
}

StatusFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  rowType: PropTypes.string.isRequired
};

export default StatusFilterMenu;